export class ApiEndPointsDocument {
    AddCompanyDocumentFolder = 'api/CompanyDocument/AddCompanyDocumentFolder';
    GetAllCompanyDocumentFolders = 'api/CompanyDocument/GetAllCompanyDocumentFolders';
    AddCompanyDocument = 'api/CompanyDocument/AddCompanyDocument';
    UploadCompanyDocument = 'api/CompanyDocument/UploadCompanyDocument';
    deleteDocument = 'api/CompanyDocument/DeleteCompanyDocument';
    DeleteCompanyPlaceholder = 'api/CompanyDocument/DeleteCompanyPlaceholder';
    getDocumentsByFolder = 'api/CompanyDocument/GetDocuments';
    getContacts = 'api/Company/GetCompanies';
    getNormalAndSharedContactContacts = 'api/Contact/GetContactSelectedContact';
    getNormalAndSharedContacts = 'api/Contact/GetCoreSelectedContact';
    getNormalAndSharedCompanyContacts = 'api/Company/GetCompanySelectedContact';
    getNormalAndSharedCompanys = 'api/Company/GetCoreSelectedCompany';
    getNormalAndSharedContactCompanys = 'api/Company/GetContactSelectedCompany';
    getNormalAndSharedContactCores = 'api/Contact/GetContactSelectedCore';
    getNormalAndSharedCompanyCores = 'api/Company/GetCompanySelectedCore';
    GetContactListCoreImplementation = 'api/Contact/GetContactListCoreImplementation';
    GetCompanyListCoreImplementation = 'api/Company/GetCompanyListCoreImplementation';
    getTransactinalRoles = 'api/Contact/GetTransactinalRoles';
    addUpdateCoreContact = 'api/Contact/addUpdateCoreContact';
    addUpdateContactContact = 'api/Contact/AddUpdateContactContacts';
    addUpdateContactCompany = 'api/Company/AddUpdateContactCompany';
    addUpdateCompanyContact = 'api/Company/AddUpdateContactUnderCompany';
    addUpdateCoreCompany = 'api/Company/addUpdateCoreCompany';
    addUpdateCoreContactRole = 'api/Contact/AddUpdateCoreContactRole';
    addUpdateContactContactRole = 'api/Contact/AddUpdateContactContactRole';
    addUpdateCompanyContactRole = 'api/Company/AddUpdateContactRoleUnderCompany';
    addUpdateCoreCompanyRole = 'api/Company/AddUpdateCoreCompanyRole';
    addUpdateContactCompanyRole = 'api/Company/AddUpdateContactCompanyRole';
    deleteSelectedContact = 'api/Contact/deleteSelectedContact';
    deleteSelectedContactContact = 'api/Contact/DeleteSelectedContactContact';
    deleteSelectedCompanyContact = 'api/Company/DeleteCompanySelectedContact';
    deleteSelectedCompany = 'api/Company/DeleteSelectedCompany';
    deleteContactSelectedCompany = 'api/Company/DeleteContactSelectedCompany';
    deleteSelectedRoleCompany = 'api/Company/DeleteSelectedCompany';
    deleteSelectedRoleContactCompany = 'api/Company/DeleteContactSelectedCompany';
    addTemplate = 'api/CompanyDocument/AddCompanyTemplate';
    renameCompanyDocumentFolder = 'api/CompanyDocument/RenameCompanyDocumentFolder';
    getAllTemplates= 'api/DocumentTemplate/GetAllTemplates';
    GetDocumentTemplatePlaceholders ='api​/DocumentTemplate​/GetDocumentTemplatePlaceholders';
    DeleteCompanyDocumentFolder  = 'api/CompanyDocument/DeleteCompanyDocumentFolder';
    appendTemplate= 'api/CompanyDocument/AppendCompanyTemplate';
    getAttachment = 'api/App/DownloadDocument';
    getDocumentsDetailsByDocumentId = 'api/CompanyDocument/GetDocumentDetails';
    UpdateDocumentsDetailsByDocumentId = 'api/CompanyDocument/UpdateCompanyDocumentDetails';
    getSharedAccesslRoles = 'api/ManageRole/GetAllRolesToLinkContactCompanyCore';
    AddCompanyItemForPlaceholder = 'api/CompanyDocument/AddCompanyItemToPlaceholder';
    GetAllCompanyDocumentPlaceholders = "api/CompanyDocument/GetAllCompanyDocumentPlaceholders";
    getFormFolderList = 'api/FormFolder/GetFormFolder';
    getFormFolderWithFormTemplates ='api/FormFolder/GetFormFolderWithFormTemplates';
    GetParentFormFolderHierarchy ='api/FormFolder/GetParentFormFolderHierarchy';
    FileManagerItemsWithHierarchy = "api/FileManager/FileManagerItemsWithHierarchy";
    getFileManagerFolderList = "api/FileManager/GetFileManagerFolders";
    DownloadDocument = "api/CompanyDocument/DownloadDocument";
    AddCreateProjectforPlaceholder = "api/CompanyDocument/AddCreateProjectforPlaceholder";
    AddProjectInfoAsTemplete="api/Project/AddProjectInfoAsTemplete";
    AddEditProjectGroupRelationParticipant = 'api/Project/AddEditProjectGroupRelationParticipant';
    AddProjectEventLog = "api/Project/AddProjectEventLog";
    AddCompanyMultiDocument = "api/CompanyDocument/AddCompanyMultiDocument";
    Reorderfolders= "api/CompanyDocument/Reorderfolders";
    ReorderPlaceholders = "api/CompanyDocument/ReorderPlaceholders";
    ReorderPlaceholdersforNewAddedPlaceholder = "api/CompanyDocument/ReorderPlaceholdersforNewAddedPlaceholder";
    ReorderfoldersforNewAddedfolder = "api/CompanyDocument/ReorderfoldersforNewAddedfolder";
    mergePdfFiles = "api/App/MergePdfFiles";
    addPortalAccessToContact = 'api/Contact/AddPortalAccessToContact';
    shareDocsOnPortal = "api/CompanyDocument/ShareDocsOnPortal";
    GetUserList ='api/ManageUser/GetUserList';
    renameCompanyDocument = "api/CompanyDocument/RenameCompanyDocument";
    canThisPdfOpenforModifyByBytes="api/App/CanThisPdfOpenforModifyByBytes";
}
